<template>
  <div class="pay-confirm" @click.self="hideConfirm">
    <div class="popupbox" style="display: block;">
      <div class="popup-title">
        <h4>充值账号：{{ userInfo.account }}</h4>
        <p>（密码:{{ userInfo.password }}）</p>
        <p class="c-red">请务必截图保存账户密码</p>
      </div>
      <ul>
        <li v-for="item in subTypes" :key="item.subTypeCode"
            @click="payHandler(item.subTypeCode, item.payConfirm, item.superiorCode, item.initiatorCode)">
          <a>
            <img v-if="item.superiorCode =='alipay'" src="../../../assets/img/icon-ali.png"/>
            <img v-else src="../../../assets/img/icon-wx.png"/>
            <h5>{{ item.subTypeDesc }}</h5>
          </a>
        </li>
      </ul>
    </div>
    <div v-if="showResult" v-html="payHtml"></div>

  </div>
</template>

<script>
import userService from '../../../services/userService'
import payService from '../../../services/payService'
import { Kkconfig } from '../../../assets/js/config'
import kkUtil from '../../../assets/js/kk-util'

export default {
  name: 'confirm',
  props: {
    payConfig: {
      type: Object,
      default: () => {}
    },
    subTypes: {
      type: Array,
      default: () => []
    },
    payPurposeId: null,
    appType: null
  },
  data () {
    return {
      payHtml: '',
      showResult: false,
      userInfo: {},
      imUrl: ''
    }
  },
  methods: {
    hideConfirm () {
      this.$emit('hide')
    },
    getUserInfo () {
      this.userInfo = userService.getLocalUserInfo()
    },
    payHandler (payChannel, payConfirm, superiorCode, initiatorCode) {
      // payService.charge(payChannel, this.payConfig.type, this.payConfig.amountLevel)
      //   .then(res => {
      //     if (res.result) {
      //       if (payChannel === 'wechat_pay') {
      //         window.location.href = res.data
      //       } else if (payChannel === 'alipay') {
      //         this.payHtml = res.data
      //         this.showResult = true
      //         setTimeout(() => {
      //           document.forms[0].submit()
      //         }, 0)
      //       }
      //     } else {
      //       alert(res.msg)
      //     }
      //   })
      let vueReturnUrl = window.location.protocol + '//' + window.location.host
      let chargePara = '?rechargerAmount=' + this.payConfig.amountLevel + '&payPurposeId=' + this.payPurposeId +
        '&payChannel=' + payChannel + '&payPurpose=' + this.payConfig.type +
        '&userId=' + userService.getLocalUserInfo().userId + '&branchId=' + userService.getBranchId() +
        '&fromDomain=' + userService.getLocalUserFrom() + '&appType=' + this.appType +
        '&vueReturnUrl=' + vueReturnUrl + '&dynamicApiUrl=' + Kkconfig.reqUrl.dynApiUrl
      let payUrl = Kkconfig.reqUrl.payUrl + '/h5/pay/apply' + chargePara
      if (initiatorCode == 'wap_pay') {
        if (payConfirm) {
          if (confirm('确定要支付吗？')) {
            window.location.href = payUrl
          } else {
          }
        } else {
          window.location.href = payUrl
        }
        //this.$router.push({name: 'user-purchase-pay', params: {goUrl: payUrl}});
      } else {
        //app支付，那么需要和原生的app进行交互
        payService.applyPay(payUrl)
          .then(res => {
            if (res.result) {
              if (superiorCode == 'wechat_pay') {
                nativePay.wechatAppPay(res.data)
              } else {
                nativePay.alipayAppPay(res.data, vueReturnUrl)
              }
            }
          })
      }
    }
  },
  mounted () {
    this.getUserInfo()
  }
}
</script>

<style scoped>
.pay-confirm {
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;
}

.pay-box {
  width: 90%;
  height: 48%;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.pay-box .c {
  width: calc(100% - 40px);
  padding: 0 20px;
}

.pay-box .a {
  color: #333333;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 15px;
}

.pay-box .a div {
  margin-bottom: 3px;
}

.pay-box .a .red-larger {
  color: #F02E0A;
  font-size: 1.2em;
}
</style>
